import {EmpleadoModel} from '../../CoreModule/models/empleado.model';
import {EmpleadoSemanaModel} from '../../FriedmanModule/models/empleado.semana.model';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {CargoEntity} from '../../CoreModule/entities/cargo.entity';
import * as moment from 'moment';
import {SemanaModel} from '../../FriedmanModule/models/semana.model';

export class EmpleadoComisionesModel {
  _id: any;
  empleado: EmpleadoModel;
  ventas: any[] = [];
  mallas: EmpleadoSemanaModel[] = [];

  cA: ComisionXCategoria = new ComisionXCategoria();
  cAA: ComisionXCategoria = new ComisionXCategoria();
  cAAA: ComisionXCategoria = new ComisionXCategoria();
  totCat: ComisionXCategoria = new ComisionXCategoria();
  totTienda: ComisionXCategoria = new ComisionXCategoria();
  pptoTienda: number = 0;
  ventasTienda:number = 0;
  total: number = 0;
  tiendas: TiendaEntity[] = [];
  cargo: CargoEntity;
  aprobado: boolean = true;
  fechaAprobacion:string = "";
  estado: any = {
    paraAprobacion: 0,
    liquidado: 0
  };
  observaciones: string[] = [];
  usuarioAprueba: string[] = [];
  fechaObs:string[] = [];

  tempObs: string = '';
  tempValueCom:number = 0;

  collapse: boolean = true;
  fechaInicio:string = "";
  fechaFin:string = "";
  tiendaMaestra:string = "";

  crearEmpleadoComisionModel(data: any) {
    // console.log(data);

    this._id = data._id;



    this.empleado = data.empleado;
    if (data.ventas)
      this.ventas = data.ventas;
    if (data.mallas)
      this.mallas = data.mallas;

    if(data.mallasTienda)
      this.pptoTienda = data.pptoTienda;

    this.ventasTienda = data.ventasTienda;

    this.cA.cargarDatos(data.cA);
    this.cAA.cargarDatos(data.cAA);
    this.cAAA.cargarDatos(data.cAAA);
    this.totCat.cargarDatos(data.totCat);
    this.totTienda.cargarDatos(data.totTienda);

    if (data.tiendas)
      this.tiendas = data.tiendas;
    this.cargo = data.cargo;
    this.aprobado = data.aprobado;
    this.usuarioAprueba = data.usuarioAprueba;
    this.observaciones = data.observaciones;
    this.fechaAprobacion = data.fechaAprobacion;
    this.estado = data.estado;
    this.tiendaMaestra = data.tiendaMaestra
    this.tempObs =  '';

    this.mallas = this.mallas.filter(m=>{
      return m.metaTotal > 0;
    });
  }

  buscarTiendaMaestra(){
    let idDBTienda = this.tiendas[this.tiendas.length -1].idDB;
    let cantidad = 0;

    for(let t of this.tiendas){
      let c = this.mallas.filter(m=> m.tienda == t.idDB && m.metaTotal > 0).length;

      if(c > cantidad){
        cantidad = c;
        idDBTienda = t.idDB;
      }
    }

    return idDBTienda
  }

  calcularComision(ventas: any[], tiendas: TiendaEntity[], fecha1: any, fecha2: any) {
    this.ventas = ventas;
    this.cA.reiniciarValores();
    this.cAA.reiniciarValores();
    this.cAAA.reiniciarValores();
    this.totCat.reiniciarValores();
    this.totTienda.reiniciarValores();



    for (let m of this.mallas) {

      let t = tiendas.find(_t => _t.idDB == m.tienda);
      if (t) {

        this.tiendas.push(t);
        let vSemana = this.ventas.filter(v => v.tienda == t.idDB && v.semana == m.semana);

        // if(m.semana == "2025-01"){
        //   console.log(vSemana);
        // }

        let totalVentasSem = 0;
        vSemana.map(v => {
          if (v.tipodoc!.includes('VN') || v.tipodoc!.includes('VE') || v.tipodoc.includes('NCE') || v.tipodoc.includes('NCC')) {
            totalVentasSem -= v.cantidad;
          }
          else{
            totalVentasSem += v.cantidad;
          }
        });

        // console.log(`${m.semana} - total ventas ${totalVentasSem}`);

        let diasProgramados = 0;
        let diasCompensados = 0;
        let totalMeta = 0;
        for (let md of m.meta) {
          let f = moment(md.fecha);
          f.seconds(0);
          f.millisecond(0);
          if (moment(f).isBetween(fecha1, fecha2,undefined,"[]")) {
            if (md.metaDia > 0) {

              //console.log(`comparando ${f.format("DD-MM-YYYY")} con ${fecha1.format("DD-MM-YYYY")} y ${fecha1.format("DD-MM-YYYY")}`);

              diasProgramados++;
              totalMeta += md.metaDia;

            } else if (md.esCompensado) {
              diasCompensados++;
            }
          }
        }

        //totalMeta = m.metaTotal;



        let cumplimiento = (totalMeta == 0) ? 0 : totalVentasSem / totalMeta * 100;



        let valor = this.devolverValorComision(cumplimiento, t.categoria, -1, diasProgramados + diasCompensados);
        // if (this.empleado.id == '16992') {
        //
        // }


        this.adicionarACategoria(t.categoria, totalVentasSem, totalMeta, cumplimiento, diasProgramados, valor, diasCompensados);
      }
    }

    this.cA.calcularCumplimiento();
    this.cAA.calcularCumplimiento();
    this.cAAA.calcularCumplimiento();

    this.calcularTotCategoria(fecha1, fecha2);

    if(this.cargo.idDB == "070"){
      this.calcularTotCatTienda(fecha1, fecha2);
    }

  }

  adicionarACategoria(categoria: string, ventas: number, meta: number, cumplimiento: number, diasProgramados: number, valor: number, diasCompensados:number) {

    switch (categoria) {
      case 'A':
        this.cA.ventas += ventas;
        this.cA.meta += meta;
        this.cA.valor += valor;
        //this.cA.cumplimiento += cumplimiento;
        this.cA.diasProgramados += diasProgramados;
        this.cA.diasCompensados += diasCompensados;
        break;
      case 'AA':
        this.cAA.ventas += ventas;
        this.cAA.meta += meta;
        this.cAA.valor += valor;
        //this.cAA.cumplimiento += cumplimiento;
        this.cAA.diasProgramados += diasProgramados;
        this.cAA.diasCompensados += diasCompensados;
        break;
      case 'AAA':
        this.cAAA.ventas += ventas;
        this.cAAA.meta += meta;
        this.cAAA.valor += valor;
        //this.cAAA.cumplimiento += cumplimiento;
        this.cAAA.diasProgramados += diasProgramados;
        this.cAAA.diasCompensados += diasCompensados;
        break;
    }
  }

  devolverValorComision(cumplimiento: number, categoria: string, cantDias:number, diasProgramados:number) {
    let comision = 0;
    let dias = 0;


    switch (categoria) {
      case 'A':

        this.cargo.A.porcentajes.map(p => {
          if (p.minimo < cumplimiento && p.maximo > cumplimiento)
            comision = p.valor;
        });

        break;
      case 'AA':
        this.cargo.AA.porcentajes.map(p => {
          if (p.minimo < cumplimiento && p.maximo > cumplimiento)
            comision = p.valor;
        });
        break;
      case 'AAA':
        this.cargo.AAA.porcentajes.map(p => {
          if (p.minimo < cumplimiento && p.maximo > cumplimiento)
            comision = p.valor;
        });
        break;

    }
    //
    //
    // if(cantDias == -1)
    //  dias = diasProgramados / cantDias;

    //
    //
    // // cantidad de semanas
    if(cantDias == -1)
      comision =  comision / 4;

    // if(cantDias == -1)
    // console.log(`la comision es de ${comision} con cumplimiento de ${cumplimiento} con el cargo ${this.cargo.nombre}`);
      return comision;

  }

  calcularTotCategoria(fecha1:any, fecha2:any) {



    this.totCat.ventas += this.cA.ventas;
    this.totCat.meta += this.cA.meta;
    this.totCat.valor += this.cA.valor;
    this.totCat.diasProgramados += this.cA.diasProgramados;
    this.totCat.diasCompensados += this.cA.diasCompensados;


    this.totCat.ventas += this.cAA.ventas;
    this.totCat.meta += this.cAA.meta;

    this.totCat.valor += this.cAA.valor;
    this.totCat.diasProgramados += this.cAA.diasProgramados;
    this.totCat.diasCompensados += this.cAA.diasCompensados;


    this.totCat.ventas += this.cAAA.ventas;
    this.totCat.meta += this.cAAA.meta;

    this.totCat.valor += this.cAAA.valor;
    this.totCat.diasProgramados += this.cAAA.diasProgramados;
    this.totCat.diasCompensados += this.cAAA.diasCompensados;




    let cantDias = fecha2.diff(fecha1,'d') + 1;


    // console.log(`total ventas ${this.totCat.ventas} y total meta ${this.totCat.meta}`);

    this.totCat.cumplimiento = this.totCat.ventas / this.totCat.meta * 100;
    // console.log(`cumplimiento ${this.totCat.cumplimiento} y categoria ${this.tiendas[0].categoria}`);
    this.totCat.valor = this.devolverValorComision(this.totCat.cumplimiento, this.tiendas[0].categoria, cantDias, this.totCat.diasProgramados + this.totCat.diasCompensados);

    let dias =  (this.totCat.diasProgramados + this.totCat.diasCompensados) / cantDias;
    // console.log(`comision de ${this.totCat.valor}`);
    // console.log(`la cantidad de dias es ${this.totCat.diasProgramados} de ${cantDias}`);
    this.totCat.valorNeto = this.totCat.valor * dias;
    // console.log(`comision promediada de ${this.totCat.valor} con coeficiente de ${dias}`);

    let cantidadMallas = 0;
    // this.mallas.map(m => {
    //   if (m.metaTotal > 0)
    //     cantidadMallas++;
    // });
    //
    // this.totCat.cumplimiento /= cantidadMallas;
  }

  devolverVentaXSemana(semana: string) {
    return this.ventas.filter(v => v.semana == semana);
  }

  calcularTotCatTienda(fecha1:any, fecha2:any){

    // console.log(`ventas de tienda ${this.ventasTienda} y ppto tienda ${this.pptoTienda}`);
    let cumplimiento = (this.pptoTienda == 0) ? 0 : this.ventasTienda / this.pptoTienda * 100;

    let cantDias = fecha2.diff(fecha1,'d') + 1;

    let tFound = this.tiendas.find(_t => _t.idDB == this.tiendaMaestra);

    if(!tFound)
      tFound = this.tiendas[this.tiendas.length-1];

    let valor = this.devolverValorComision(cumplimiento, tFound.categoria, cantDias, this.totCat.diasProgramados);

    let dias =  (this.totCat.diasProgramados + this.totCat.diasCompensados) / cantDias;

    this.totTienda.valorNeto = valor * dias;

    this.totTienda.ventas += this.ventasTienda;
    this.totTienda.meta += this.pptoTienda;
    this.totTienda.valor = valor;
    this.totTienda.cumplimiento += cumplimiento;
    this.totTienda.diasProgramados += this.totCat.diasProgramados;
    this.totTienda.diasCompensados += this.totCat.diasCompensados;
  }

}

export class EmpleadoComisionType{
  _id:any;

  cA: ComisionXCategoria = new ComisionXCategoria();
  cAA: ComisionXCategoria = new ComisionXCategoria();
  cAAA: ComisionXCategoria = new ComisionXCategoria();
  totCat: ComisionXCategoria = new ComisionXCategoria();
  cargo: CargoEntity;
  aprobado: boolean = true;
  estado: any = {
    paraAprobacion: 0,
    liquidado: 0
  };
  observaciones: string[] = [];
  usuarioAprueba: string[] = [];
  fechaObs:string[] = [];
  fechaInicio:string = "";
  fechaFin:string = "";
}

export class ComisionXCategoria {
  ventas: number = 0;
  meta: number = 0;
  cumplimiento: number = 0;
  valor: number = 0;
  valorNeto:number = 0;
  diasProgramados: number = 0;
  diasCompensados:number = 0;



  cargarDatos(data: any) {
    if(data) {
      this.ventas = data.ventas;
      this.meta = data.meta;
      this.cumplimiento = data.cumplimiento;
      this.valor = data.valor;
      this.valorNeto = data.valorNeto;
      this.diasProgramados = data.diasProgramados;
      this.diasCompensados = data.diasCompensados;
    }
  }

  reiniciarValores() {
    this.cumplimiento = 0;
    this.ventas = 0;
    this.meta = 0;
    this.valor = 0;
    this.diasProgramados = 0;
    this.diasCompensados = 0;
  }

  calcularCumplimiento() {

    this.cumplimiento = (this.meta == 0) ? 0 : this.ventas / this.meta;
    this.cumplimiento *= 100;
  }
}
